const DEFAULT_LOCAL_API_URL = 'http://localhost:8000';
const DEFAULT_DEPLOYED_API_URL = 'https://webapi.packops.14bis.aero';

function trimTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, '');
}

function readEnv(name: string): string {
  return String(process.env[name] || '').trim();
}

function isLoopbackHost(hostname: string): boolean {
  const normalized = hostname.trim().toLowerCase();
  return (
    normalized === 'localhost' ||
    normalized === '127.0.0.1' ||
    normalized === '0.0.0.0' ||
    normalized === '::1' ||
    normalized === '[::1]'
  );
}

const browserHostname =
  typeof window === 'undefined' ? 'localhost' : window.location.hostname;

export const IS_LOCAL_FRONTEND = isLoopbackHost(browserHostname);

export const LOCAL_API_URL = trimTrailingSlashes(
  readEnv('REACT_APP_LOCAL_API_URL') || DEFAULT_LOCAL_API_URL
);

export const DEPLOYED_API_URL = trimTrailingSlashes(
  readEnv('REACT_APP_DEPLOYED_API_URL') || DEFAULT_DEPLOYED_API_URL
);

export const API_URL = IS_LOCAL_FRONTEND ? LOCAL_API_URL : DEPLOYED_API_URL;

export const API_TARGET = IS_LOCAL_FRONTEND ? 'local' : 'deployed';

if (typeof window !== 'undefined') {
  // Keep this log while finishing the migration. It makes stale bundles and
  // hard-coded URLs obvious in the browser console.
  console.info('[PackOps API configuration]', {
    target: API_TARGET,
    frontendOrigin: window.location.origin,
    apiUrl: API_URL,
  });
}
